import React from "react";
import { Row } from "reactstrap";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";

export type SuitePageShellProps = {
  heading: React.ReactNode;
  children: React.ReactNode;
  afterBreadcrumb?: React.ReactNode;
};

export default function SuitePageShell({
  heading,
  children,
  afterBreadcrumb
}: SuitePageShellProps) {
  return (
    <div className="suite-page-shell">
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer heading={heading} />
          <Separator className="mb-4" />
          {afterBreadcrumb}
        </Colxx>
      </Row>
      {children}
    </div>
  );
}
